<template>
  <div>
    <div class="claim-card card">
      <div class="user-name d-flex user">
        <div class="avatar-cont">
          <a-avatar
            @click="routeToProfile()"
            :style="{
              color: ' #ffffff !important',
              'background-color': '#C997C5',
              display: 'flex',
              'align-items': 'center',
              cursor: 'pointer'
            }"
            :size="70"
            :src="info.image ? info.image : info.url ? info.url : null"
            class="text-capitalize"
          >
            {{ getInformation("name")[0] }}
          </a-avatar>
          <div class="rating-cont">
            <div class="review-star">
              <ReviewStar
                :rating="
                  info.overall_rating != undefined
                    ? info.overall_rating.toFixed(1)
                    : 0
                "
              />
            </div>
            <span class="rating-text"
              >{{
                info.overall_rating != undefined
                  ? info.overall_rating.toFixed(1)
                  : 0
              }}
              stars</span
            >
            <span class="rating-text">0 reviews</span>
          </div>
        </div>
        <div class="divider"></div>
        <div class="right-items profile-btn item">
          <div class="title-cont">
            <p
              class=" bold-text text-truncate cp extra"
              :style="{
                color: '#0F1734',
                'font-weight': '700',
                'font-size': '20px',
                'line-height': '30px',
                'margin-bottom': '4.5px'
              }"
              @click="routeToProfile()"
            >
              {{ getInformation("name") }}
            </p>
            <span v-if="getInformation('title')" class="tag"  :style="{color: getPrimaryColor(), background: getPrimary50Color()}">
              {{ getInformation("title") }}
            </span>
          </div>
          <div class="midl-cont">
            <span v-if="info.phone_number" class="text-norm">
              <font-awesome-icon
                size="1x"
                :icon="['fal', 'phone-alt']"
                :style="{ color: '#94A3B8' }"
              />
              {{ info.phone_number }}
            </span>
            <span v-if="info.address" class="loc-text">
              <font-awesome-icon
                size="1x"
                :icon="['fal', 'map-marker-alt']"
                :style="{ color: '#94A3B8' }"
              />
              <div class="loc-cont">
                <span :style="{ color: '#94A3B8' }" v-if="info.city">
                  {{ info.city }}, {{ info.state }}
                  <br />
                  {{
                    info.address
                      .split(" ")
                      .filter(sttr => sttr !== "None,")
                      .join(" ")
                  }}
                </span>
                <span v-else>
                  {{
                    info.address
                      .split(" ")
                      .filter(sttr => sttr !== "None,")
                      .join(" ")
                  }}
                </span>
              </div>
            </span>
            <span v-if="info.hasOwnProperty('distance')" class="text-norm2">
              {{ getInformation("distance") }}
              miles away
            </span>
          </div>
          <div class="meet-others">
            <div class="btn-container1">
              <div
                :disable="addCircleButtonText === 'In your circle'"
                class="btn-primary1"
                v-bind:style="
                  addCircleButtonText === 'In your circle'
                    ? {
                        background: '#E2E8F0',
                        'pointer-events': 'none',
                        width: '161px',
                        color: '#47556E',
                        'align-items': 'center',
                        'justify-content': 'center',
                        gap: '4px'
                      }
                    : { background: getPrimaryColor(), cursor: 'pointer' }
                "
                @click="addVirtualDocToCircle(info)"
              >
                <div
                  v-if="
                    loadingbtn === info.id
                      ? info.id
                      : this.affiliatedId
                      ? this.affiliatedId
                      : this.$route.params.id
                  "
                  class="spinner-border spinner-border2 position-absolute spinner-class"
                ></div>
                <font-awesome-icon
                  v-if="addCircleButtonText === 'In your circle'"
                  size="lg"
                  :style="{ transform: 'scale(1.0)', color: '#47556E' }"
                  :icon="['fal', 'check']"
                />
                {{ addCircleButtonText }}
                <!-- <i
                              class="fa fa-check font-white"
                              aria-hidden="true"
                              v-if="addCircleButtonText === 'In your circle'"
                              ></i> -->
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            loading === info.id
              ? info.id
              : this.affiliatedId
              ? this.affiliatedId
              : this.$route.params.id
          "
          class="spinnerContainer2"
        >
          <a-spin size="large" />
        </div>
      </div>
    </div>
    <RecommendOthersModal ref="recommendOthersModal" :fetchUser="fetchDoc" />
    <RecommendDoctorModal ref="recommendDoctorModal" :fetchUser="fetchDoc" />
  </div>
</template>

<script>
const svg1 = require("../../../assets/icon-check-badge.svg");
const svg2 = require("../../../assets/icon-uncheck-badge.svg");
import RecommendDoctorModal from "../../Modals/RecommendDoctor";
import RecommendOthersModal from "../../Modals/RecommendOthers";
import UserRepository from "../../../repositories/userRepository.js";
import ReviewStar from "../../Users/Doctor/reviewstarforcircle.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck } from "@fortawesome/pro-light-svg-icons";
library.add(faCheck);
export default {
  name: "NewCard",
  components: {
    RecommendDoctorModal,
    RecommendOthersModal,
    ReviewStar
  },
  data() {
    return {
      activeIcon: null,
      loadingbtn: null,
      loading: false,
      addCircleButtonText: this.info.on_circle
        ? "In your circle"
        : "Add To Circle",
      showReview: this.type === "nfp" ? false : true,
      defaultHospitalImage:
        "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/Hospital.svg",
      defaultClinicImage:
        "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/Clinic.svg",
      defaultNfpImage:
        "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/nfp-icon.svg"
    };
  },
  methods: {
    openReviewModal(info) {
      //this.$refs.recommendDoctorModal.show({ ...info, role: this.type === "hcps" ? "hcp" : this.type });

      console.log("type ->", this.type);
      console.log("info ->", info);

      switch (this.type) {
        case "hcps":
        case "hcp":
          this.$refs.recommendDoctorModal.show({
            ...info,
            role: "hcp",
            page: this.page,
            inPersonReview: info.in_person_visit,
            onlineReview: info.online_tele_medicine,
            myCirclesReview: info.my_circle
          });
          break;
        case "clinic":
          this.$refs.recommendOthersModal.show({
            ...info,
            role: "clinic",
            page: this.page
          });
          break;
        case "hospital":
          this.$refs.recommendOthersModal.show({
            ...info,
            role: "hospital",
            page: this.page
          });
          break;
        case "providers":
          this.$refs.recommendDoctorModal.show({
            ...info,
            role: "doctor",
            page: this.page,
            inPersonReview: info.in_person_visit,
            onlineReview: info.online_tele_medicine,
            myCirclesReview: info.my_circle
          });
          break;
        case "doctor":
          this.$refs.recommendDoctorModal.show({
            ...info,
            role: "doctor",
            id: this.affiliatedId,
            page: this.page,
            inPersonReview: info.in_person_visit,
            onlineReview: info.online_tele_medicine,
            myCirclesReview: info.my_circle
          });
          break;
        default: {
          this.$refs.recommendDoctorModal.show({
            ...info,
            role: this.type,
            page: this.page,
            inPersonReview: info.in_person_visit,
            onlineReview: info.online_tele_medicine,
            myCirclesReview: info.my_circle
          });
        }
      }
    },
    addVirtualDocToCircle(info) {
      console.log("info ->", info);
      const id = info.id
        ? info.id
        : this.affiliatedId
        ? this.affiliatedId
        : this.$route.params.id;

      this.loadingbtn = id;
      console.log(this.loadingbtn);
      const idParam =
        this.type === "doctor" ||
        this.type === "hospital_administrator" ||
        this.type === "clinic_administrator" ||
        this.type === "nfp_administrator"
          ? info
          : id;
      UserRepository.addUserByTypeToCircle(
        idParam,
        this.currentCircle.id,
        this.type
      )
        .then(res => {
          this.loadingbtn = false;
          this.$notification.success({
            message: "Success",
            description: res.data.message
          });
          this.addCircleButtonText = "In your circle";
        })
        .catch(err => {
          this.$notification.info({
            message: "Information",
            description: err.response.data.message
          });
          if (err.response.data.message == "already added") {
            this.addCircleButtonText = "In your circle";
          }
          this.loadingbtn = false;
          //this.addCircleButtonText = "ADD TO CIRCLE";
        });
      //this.$emit("addVirtualDocToCircle", info);
    },
    routeToProfile() {
      this.loading = this.info.id ? this.info.id : this.affiliatedId;
      let data = { ...this.info, role: this.type };

      switch (this.type) {
        case "physician":
          this.viewEntityProfile({
            ...this.info,
            role: "doctor",
            id: this.info.id ? this.info.id : this.affiliatedId
          });

          break;
        case "doctor":
          console.log("doctor");
          console.log(this.id);
          this.viewEntityProfile({
            ...this.info,
            role: "doctor",
            // id: this.info.id ? this.info.id : this.affiliatedId
            id: this.id
          });

          break;
        case "providers":
          data.ext_ref_id
            ? this.viewEntityProfile({ ...this.info, role: "doctor" })
            : this.viewProfile({
                ...this.info,
                role: "doctor",
                id: this.info.id
              });
          break;
        case "other":
          this.viewEntityProfile({ ...this.info, role: "hcp" });
          break;
        case "hcps":
          this.viewEntityProfile({ ...this.info, role: "hcp" });
          break;
        case "hospital":
          this.info.id
            ? this.viewEntityProfile({ ...this.info, role: "hospital" })
            : this.viewProfile({
                ...this.info,
                role: "hospital_administrator",
                id: this.info.id
              });
          break;
        case "clinic":
          this.viewEntityProfile(data);
          break;
        case "nfp":
          this.viewEntityProfile(data);
          break;
      }
    },
    getInformation(value) {
      switch (this.type) {
        case "physician": {
          switch (value) {
            case "name":
              return `${this.info.first_name} ${this.info.last_name}, ${this
                .info.title || ""}`;
            case "title":
              return `${this.info.speciality ||
                this.info.physician_speciality ||
                ""}`;
            case "area":
              return this.info.areas_of_practice &&
                this.info.areas_of_practice.length
                ? this.info.areas_of_practice[0]
                : null;
            case "plusarea":
              return this.info.areas_of_practice &&
                this.info.areas_of_practice.length
                ? this.info.areas_of_practice.length - 1
                : null;
            case "image":
              let default_image =
                "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/";
              default_image +=
                this.info.gender === "m"
                  ? "MALE DOCTOR2x.png"
                  : "WOMAN DOCTOR2x.png";
              return this.info.picture
                ? `url('${this.info.picture}')`
                : `url('${default_image}')`;
             case "distance":
             return this.info.distance[0].toFixed(2);
            default:
              return;
          }
        }
        case "hospital": {
          switch (value) {
            case "name":
              return this.info.hospital_name
                ? this.info.hospital_name
                : this.info.display_name;
            case "title":
              return this.info.hospital_type_desc || "";
            case "area":
              return this.info.specialist_tag
                ? this.info.specialist_tag[0]
                : null;
            case "plusarea":
              return this.info.specialist_tag
                ? this.info.specialist_tag - 1
                : null;
            case "image":
              if (this.info.image) {
                return `url('${this.info.image}')`;
              }
              if (this.info.picture) {
                return `url('${this.info.picture}')`;
              }
              if (this.info.url) {
                return `url('${this.info.url}')`;
              }
            case "distance":
              return this.info.distance.toFixed(2);
            default:
              return;
          }
        }
        case "clinic": {
          switch (value) {
            case "name":
              return this.info.clinic_name
                ? this.info.clinic_name
                : this.info.display_name;
            case "title":
              return this.info.clinic_type_desc || "";
            case "area":
              return this.info.specialist_tag
                ? this.info.specialist_tag[0]
                : null;
            case "plusarea":
              return this.info.specialist_tag
                ? this.info.specialist_tag - 1
                : null;
            case "image":
              return this.info.image
                ? `url('${this.info.image}')`
                : `url('${this.defaultClinicImage}')`;
             case "distance":
              return this.info.distance.toFixed(2);
            default:
              return;
          }
        }
        case "nfp": {
          switch (value) {
            case "name":
              return this.info.nfp_name;
            case "title":
              return this.info.nfp_name ? this.info.nfp_name : null;
            case "area":
              return this.info.nfp_type ? this.info.nfp_type : null;
            case "plusarea":
              return null;
            case "image":
              return this.info.image
                ? `url('${this.info.image}')`
                : `url('${this.defaultNfpImage}')`;
            case "distance":
              return this.info.distance.toFixed(2);
            default:
              return "";
          }
        }
        default:
          switch (value) {
            case "name":
              return `${this.info.first_name} ${this.info.last_name}${
                this.info.title !== null
                  ? `, ${this.info.title || ""}`
                  : "" || ""
              }`;
            case "title":
              return `${this.info.speciality ||
                this.info.physician_speciality ||
                ""}`;
            case "area":
              return this.info.areas_of_practice &&
                this.info.areas_of_practice.length
                ? this.info.areas_of_practice[0]
                : null;
            case "plusarea":
              return this.info.areas_of_practice &&
                this.info.areas_of_practice.length
                ? this.info.areas_of_practice.length - 1
                : null;
            case "image":
              let default_image =
                "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/";
              default_image +=
                this.info.gender === "m" || "M"
                  ? "MALE DOCTOR2x.png"
                  : "WOMAN DOCTOR2x.png";
              return this.info.image
                ? `url('${this.info.image}')`
                : `url('${default_image}')`;
             case "distance":
              return this.info.distance.toFixed(2);
            default:
              return;
          }
          return;
      }
    }
  },

  props: {
    id: Number,
    info: Object,
    type: String,
    hideBtn: Boolean,
    isSelf: Boolean,
    affiliatedId: Number,
    page: Number,
    fetchDoc: Function
  },

  created() {
    this.activeIcon = this.info.is_verified ? svg1 : svg2;
  }
};
</script>

<style lang="scss" scoped>
.spinnerContainer2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.2);
}

.spinner-border2 {
  width: 1rem !important;
  height: 1rem !important;
}
.user {
  align-items: center;
  @media screen and (max-width: 700px) {
    height: 283px !important;
  }
}
.card {
  margin-bottom: 16px;
  border: 1px solid #e2e8f0 !important;
  flex-direction: row !important;
}
.loc-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.divider {
  width: 1px;
  height: 177px;
  background-color: #cbd5e1;
  @media screen and (max-width: 700px) {
    height: 100%;
    margin-top: 0px;
  }
}

.btn-container1 {
  @media (max-width: 700px) {
    // position: absolute;
    // top: 50%;
    // transform: translateY(-50%);
    // margin-left: 15px;
    width: 100%;
  }
  .btn-primary1 {
    border-radius: 6px;
    color: #ffffff;
    font-family: Lato;
    font-size: 14px;
    line-height: 24px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
    padding: 12px 24px;
    max-width: 161px;
    min-width: 132px;

    @media screen and (max-width: 900px) {
      padding: 7px 5px;
    }
  }
  .btn-secondary1 {
    border-radius: 17.5px;
    color: #f5b255;
    margin-top: 10px;
    background: #fff;
    font-family: Lato;
    font-size: 12px;
    padding: 5px 6px;
    font-weight: bold;
    text-align: center;
    max-width: 126px;
    min-width: 99px;
  }
}
.meet-others {
  display: flex;
  align-items: center;
  @media screen and (max-width: 700px) {
    margin-left: 15.5px;
    display: none;
  }
  button {
    display: flex;
    font-size: 14px;
    border-radius: 6px;
    padding: 12px 24px;
    width: 126px;
    height: 48px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    @media screen and (max-width: 700px) {
      margin-left: 15.5px;
      justify-content: center;
      width: 100%;
    }
  }
  span {
    font-size: 14px !important;
  }
}
.title-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 17px;
  width: 210.5px;
  @media screen and (max-width: 700px) {
    width: 100%;
    margin-left: 15.5px;
    width: 170.5px;
  }
}

.extra {
  width: 213.5px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}
.middle-item-cont {
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 100%;
  @media screen and (max-width: 700px) {
    flex-direction: column;
    width: 100%;
  }
}

.item {
  gap: 20px;
  display: flex;
  padding: 24px;
  @media screen and (max-width: 700px) {
    flex-direction: column;
    width: 100%;
    margin-left: 0px;
    padding: 10px;
  }
}
.text-norm2 {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
  margin-left: 18px;
}
.text-norm {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
  gap: 8px;
}

.loc-text {
  gap: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
  display: flex;
  align-items: center;
}
.midl-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  width: 210.5px;
  @media screen and (max-width: 700px) {
    width: 100%;
    margin-left: 15.5px;
  }
}
.rating-text {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  /* or 117% */

  text-align: center;

  /* Gray/900 */

  color: #0f1734;
}
.rating-cont {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 4px;

  width: 88.53px;
  height: 48px;
}
.avatar-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 24px;
  gap: 8px;
  @media screen and (max-width: 700px) {
    align-self: flex-start;
  }
}

.tag {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  // min-width: 112px;
  min-height: 22px;
  background: #e1eaf7;
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #2a71d4;
}

.con {
  margin-bottom: 16px;
}
.loc-cont {
  display: flex;
  padding: 0px;
  gap: 4px;
  min-width: 152px;
  // min-height: 42px;
}
.number {
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}
.info-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  min-width: 213.5px;
  min-height: 111px;
}

.review-text {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  /* or 117% */

  text-align: center;

  /* Gray/900 */

  color: #0f1734;
}
.cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;

  width: 93px;
  height: 126px;
}
.prov-name {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  min-width: 112px;
  height: 22px;
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
}
.card-container {
  border: 1px solid rgba(15, 116, 189, 0.3);
  border-radius: 6px;
  background-color: #ffffff;
  transition: 0.3s all linear;
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;

  &:hover {
    border: 1px solid #a3cce6;
    background-color: #eff5fb;
    transform: scale(1.023);
  }
  .item-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 22px 16px;
    .user-img {
      height: 73px;
      width: 73px;
      cursor: pointer;
      border-radius: 50%;
      border: 1px solid #ccc;
      background-position: center !important;
      background-size: cover !important;
      background-repeat: no-repeat !important;
    }
    .rating {
      margin-top: 6px;
      padding: 1px 5px;
      border-radius: 10px;
      background-color: #f5b255;
      color: #ffffff;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
    }
    .review {
      font-family: Lato;
      font-size: 8px;
      font-weight: bold;
      text-align: center;
      margin-top: 4px;
    }
  }
  .item-right {
    overflow: auto;
    flex: 1;
    padding: 22px 16px;

    .promoted-label {
      border-radius: 7px;
      background-color: rgba(247, 181, 0, 0.25);
      color: #f98e46 !important;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      align-self: center;
      text-align: center;
      padding: 4px 10px;
      width: 89px;
      margin: 0;
      text-transform: uppercase;
      margin-bottom: 10px;
    }
    .provider-name {
      color: #333333;
      font-family: Lato;
      font-size: 20px;
      cursor: pointer;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .provider-title {
      color: rgba(51, 51, 51, 0.87) !important;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
    }
    .provider-desc {
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      color: #0f74bd;
    }
    .tags {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 12px -5px 0 -5px;

      @media screen and (max-width: 900px) {
        margin-bottom: 5px;
      }

      .crown {
        border-radius: 7px;
        background-color: rgba(247, 181, 0, 0.25);
        color: #f98e46;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        margin: 0px 5px;
        padding: 4px 10px;
      }
      .tag {
        border-radius: 7px;
        background-color: rgba(245, 178, 85, 0.25);
        color: #f98e46;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        margin: 0px 5px;
        padding: 4px 10px;
      }
    }
    .btn-container1 {
      @media (max-width: 700px) {
        // position: absolute;
        // top: 50%;
        // transform: translateY(-50%);
        // margin-left: 15px;
        width: 100%;
      }
      .btn-primary1 {
        border-radius: 17.5px;
        background-color: #f5b255;
        color: #ffffff;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 10px;
        padding: 5px 6px;
        max-width: 126px;
        min-width: 99px;

        @media screen and (max-width: 900px) {
          padding: 7px 5px;
        }
      }
      .btn-secondary1 {
        border-radius: 17.5px;
        color: #f5b255;
        margin-top: 10px;
        background: #fff;
        font-family: Lato;
        font-size: 12px;
        padding: 5px 6px;
        font-weight: bold;
        text-align: center;
        max-width: 126px;
        min-width: 99px;
      }
    }
    .contact-number {
      color: #333333;
      font-family: Lato;
      font-size: 16px;
      font-weight: bold;
    }
    .address {
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: #94a3b8;
    }
    .distance {
      color: #333333;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      margin-left: 15px;
    }
  }
}
@media screen and (max-width: 581px) {
  .card-container .item-right .provider-name {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/MedicalDirectories/NewCard.vue